//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Goldman',
  data() {
    return {
      defaultJson:{
        "High-risk Surgery": "高危手术",
        "Non sinus rythm (or APBs)": "非窦性心律（或房早）",
        "Preop. MI within 6 months": "手术前 6 月内心梗史",
        "VPBs > 5\/min at any time": "任意时刻室早 > 5 次\/分",
        "Emergency Surgery": "急诊手术",
        "Class II": "II 级（中危）",
        "Class III": "III 级（高危）",
        "poorMedicalStatusLabel": "符合以下任意一项：\n• PO₂ < 60 mmHg（8 kPa）\n• PCO₂ > 50 mmHg（6.7 kPa）\n• K < 3 mEq\/L\n• HCO₃ < 20 mEq\/L\n• BUN > 50 mg\/dL（尿素 > 18 mmol\/L）\n• 肌酐 > 3 mg\/dL（260 µmol\/L）\n• SGOT（AST）升高\n• 慢性肝病\n• 非心脏原因卧床不起",
        "Poor General Medical Status": "全身情况差",
        "Significant aortic stenosis": "显著的主动脉狭窄",
        "Class IV": "IV 级（极高危）",
        "highRiskSurgeryLabel": "腹腔、胸腔或主动脉手术",
        "Class I": "I 级（低危）",
        "S-3 or Jugular Venous Distention": "可及第三心音（S-3）或颈静脉充盈",
        "Age": "年龄"
      },
      form:{
        age:'',
        myoInfaction:'0',
        aoStenosis:'0',
        nonSinus:'0',
        pVC:'0',
        s3Gallop:'0',
        poorMedicalStatus:'0',
        highRiskSx:'0',
        emergencySx:'0',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'无',shortName:'无'},
        {value:"1",name:'轻度肝病',shortName:'轻度'},
        {value:"3",name:'中重度肝病',shortName:'中重度'},
      ],
      dataList2:[
        {value:"0",name:'否',shortName:'否'},
        {value:"1",name:'糖尿病',shortName:'是'},
        {value:"2",name:'糖尿病伴终末期器官损伤',shortName:'伴脏器受损'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
      // (age > 70 ? 5 : 0) + (myoInfaction ? 10 : 0) + (s3Gallop ? 11 : 0) + (aoStenosis ? 3 : 0) + (nonSinus ? 7 : 0) + (pVC ? 7 : 0) + (poorMedicalStatus ? 3 : 0) + (highRiskSx ? 3 : 0) + (emergencySx ? 4 : 0)
        let result = (form.age > 70 ? 5 : 0) + (form.myoInfaction ? 10 : 0) + (form.s3Gallop ? 11 : 0) + (form.aoStenosis ? 3 : 0) + (form.nonSinus ? 7 : 0) + (form.pVC ? 7 : 0) + (form.poorMedicalStatus ? 3 : 0) + (form.highRiskSx ? 3 : 0) + (form.emergencySx ? 4 : 0)
        	
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Goldman.vue